var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.9545C0 21.3782 0.46914 20.9091 1.04547 20.9091H20.5618C21.1381 20.9091 21.6073 21.3782 21.6073 21.9545C21.6073 22.5322 21.1381 23 20.5618 23H1.04547C0.46914 23 0 22.5322 0 21.9545Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5125 8.75418C18.1047 9.16324 17.4422 9.16324 17.0344 8.75418L10.8034 2.52452L4.57243 8.75418C4.16468 9.16324 3.50214 9.16324 3.09439 8.75418C2.68664 8.34643 2.68664 7.68389 3.09439 7.27614L10.0637 0.306791C10.4728 -0.102264 11.134 -0.102264 11.5431 0.306791L18.5124 7.27614C18.9202 7.68389 18.9202 8.34643 18.5125 8.75418Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8038 17.425C10.2261 17.425 9.7583 16.9559 9.7583 16.3796V2.43951C9.7583 1.86188 10.2261 1.39404 10.8038 1.39404C11.3814 1.39404 11.8492 1.86188 11.8492 2.43951V16.3796C11.8492 16.9559 11.3814 17.425 10.8038 17.425Z",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.6e6a0f8b8dc3f4a6223c345d0e830ffb.svg";
export { ForwardRef as ReactComponent };